import React, { FC } from 'react';
import { Grid, Typography } from '@mui/material';
import { GameCurrency, GameCurrencyWithFee } from 'modules/game-payments/components';
import { DefaultDisplayValue } from 'app/enums';

interface TooltipProps {
  teamsSize: string | number;
  firstPlacePrize: number;
  totalPrize: number;
  entryFee: number;
  isSinglePlayer: boolean;
}

export const TournamentTileFooterTooltipContent: FC<TooltipProps> = ({
  teamsSize,
  firstPlacePrize,
  totalPrize,
  entryFee,
  isSinglePlayer,
}) => {
  return (
    <Grid container>
      <Grid item xs={6}>
        <Typography variant="subtitle2">{isSinglePlayer ? 'Players' : 'Teams'}</Typography>
      </Grid>
      <Grid item xs={6}>
        <Typography variant="subtitle2">{teamsSize}</Typography>
      </Grid>
      <Grid item xs={6}>
        <Typography variant="subtitle2">Total prize</Typography>
      </Grid>
      <Grid item xs={6}>
        <Typography variant="subtitle2">
          {totalPrize ? <GameCurrency amount={totalPrize} noColor /> : DefaultDisplayValue.DASH}
        </Typography>
      </Grid>
      <Grid item xs={6}>
        <Typography variant="subtitle2">1st place prize</Typography>
      </Grid>
      <Grid item xs={6}>
        <Typography variant="subtitle2">
          {firstPlacePrize ? (
            <GameCurrency amount={firstPlacePrize} noColor />
          ) : (
            DefaultDisplayValue.DASH
          )}
        </Typography>
      </Grid>
      <Grid item xs={6}>
        <Typography variant="subtitle2">Entry</Typography>
      </Grid>
      <Grid item xs={6}>
        <Typography variant="subtitle2">
          <GameCurrencyWithFee amount={entryFee} showZeroLabel showUsdEquivalent />
        </Typography>
      </Grid>
    </Grid>
  );
};
